import { ContactMe } from "../../models/ContactMe";

export abstract class IContactMeRepository {
    abstract getLatestContactMe: () => Promise<ContactMe | undefined>;
}